import { createSlice } from "@reduxjs/toolkit";

const persistedDisplaySettings = (() => {
  try {
    const raw = localStorage.getItem("displaySettings");
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
})();

const initialState = {
  fontSize: "small", // small | medium | large
  charSpacing: "normal", // normal | wide | xwide
  isDarkMode: false,
  ...(persistedDisplaySettings || {}),
};

const displaySettingsSlice = createSlice({
  name: "displaySettings",
  initialState,
  reducers: {
    setFontSize: (state, action) => {
      state.fontSize = action.payload;
    },
    setCharSpacing: (state, action) => {
      state.charSpacing = action.payload;
    },
    setDarkMode: (state, action) => {
      state.isDarkMode = action.payload;
    },
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
    },
  },
});

export const { setFontSize, setCharSpacing, setDarkMode, toggleDarkMode } =
  displaySettingsSlice.actions;

export const selectFontSizeSetting = (state) => state.displaySettings.fontSize;
export const selectCharSpacingSetting = (state) =>
  state.displaySettings.charSpacing;
export const selectDarkMode = (state) => state.displaySettings.isDarkMode;

export default displaySettingsSlice.reducer;
